import toastr from 'toastr';
import { userAtom } from '../atoms/userAtom';
import { getRecoil } from 'recoil-nexus';
import loginActions from '../actions/loginActions';

const apiUtils = {};
const GetConfig = async () => {
  const res = await fetch('../../appsettings.json');
  let data;
  try {
    data = await res.json();
  } catch (e) {
    console.log('error:', e);
  }
  return data;
};

apiUtils.getConfig = GetConfig;

apiUtils.checkStatus = response => {
  if ((response.status >= 200 && response.status < 300)) {
    return response;
  } else if (response.status === 403) {
    return apiUtils.Unauthorized();
  } else {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
};

apiUtils.getFetchParameters = (method, body, removeAuth) => {
  const user = getRecoil(userAtom);
  const param = {
    method,
    headers: { 'Content-Type': 'application/json' }
  };

  if (!removeAuth) {
    param.headers.Authorization = 'Bearer ' + user.accessInfo.accessToken;
  }
  if (body) {
    param.body = JSON.stringify(body);
  }

  return param;
};

const MSG_ARQUIVO_GRANDE = 'O arquivo enviado excede o tamanho máximo permitido. Divida a planilha em arquivos menores e tente novamente.';
const MSG_FALHA_COMUNICACAO = 'Não foi possível comunicar com o servidor. Verifique sua conexão e tente novamente. Se estiver enviando um arquivo grande, ele pode ter excedido o tamanho máximo permitido.';

// Mesmo formato de erro que a API devolve ({ error: { message } }), para os chamadores tratarem normalmente
const respostaErro = message => ({ error: { message } });

apiUtils.exec = async (endpoint, params) => {
  var internalParams = params || apiUtils.getFetchParameters('GET');
  const config = await GetConfig();
  const url = config.apiUrl + endpoint;

  let res;
  try {
    res = await fetch(url, internalParams);
  } catch (err) {
    // Falha de rede: não é problema de sessão, então não desloga.
    // Um corpo acima do limite do servidor costuma chegar aqui (conexão encerrada) em vez de um 413.
    // eslint-disable-next-line no-console
    console.log('Error: ', err);
    return respostaErro(MSG_FALHA_COMUNICACAO);
  }

  if (res.status >= 200 && res.status < 300) {
    try {
      return await res.json();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error: ', err);
      return respostaErro('O servidor retornou uma resposta inválida.');
    }
  }

  if (res.status === 401) {
    // eslint-disable-next-line no-console
    console.log('API returned 401');
    loginActions.quit();
    // Force iterruption of promise
    return Promise.reject();
  }

  if (res.status === 403) {
    return apiUtils.Unauthorized();
  }

  if (res.status === 413) {
    return respostaErro(MSG_ARQUIVO_GRANDE);
  }

  try {
    const body = await res.json();
    if (body && body.error) return body;
  } catch (err) {
    // corpo vazio ou não-JSON: segue para a mensagem genérica
  }

  return respostaErro(`Erro ao processar a solicitação no servidor (código ${res.status}).`);
};

apiUtils.isActive = () => {
  const user = getRecoil(userAtom);
  return user.accessInfo.accessToken !== null;
};

apiUtils.execAsync = async (endpoint, params) => {
  var internalParams = params || apiUtils.getFetchParameters('GET');
  const config = await GetConfig();
  const url = config.apiUrl + endpoint;

  const res = await fetch(url, internalParams);

  if (res && res.status === 403) {
    return apiUtils.Unauthorized();
  }

  return res.json();
};

apiUtils.Unauthorized = () => {
  toastr.error('Usuário não tem acesso a essa funcionalidade.');
};

apiUtils.execDownload = async (endpoint, params) => {
  const config = await GetConfig();
  const url = config.apiUrl + endpoint;
  return executeDownload(url, params);
};

const executeDownload = async (url, params) => {
  var internalParams = params || apiUtils.getFetchParameters('GET');
  
  let res;
  try {
    res = await fetch(url, internalParams);
  } catch (err) {
    // Falha de rede: não é problema de sessão, então não desloga
    // eslint-disable-next-line no-console
    console.log('Error: ', err);
    toastr.error('Não foi possível comunicar com o servidor para baixar o arquivo. Verifique sua conexão e tente novamente.');
    return Promise.reject(err);
  }

  if (res.status >= 200 && res.status < 300) {
    return res.blob();
  }

  if (res.status === 401) {
    loginActions.quit();
    // Force iterruption of promise
    return Promise.reject();
  }

  if (res.status === 403) {
    apiUtils.Unauthorized();
  } else {
    toastr.error(`Não foi possível baixar o arquivo (código ${res.status}).`);
  }

  // Os chamadores usam o retorno direto como Blob; interrompe para não tentarem baixar uma resposta de erro
  return Promise.reject(new Error(`Download falhou com status ${res.status}`));
};

export default apiUtils;
